/** The goal page's tabs, in order. */
export const GOAL_TABS = ['summary', 'plan', 'overview'] as const

export type GoalTab = (typeof GOAL_TABS)[number]
